import { FC, useCallback } from 'react';
import { useInfinityScroll } from 'react-utils';
import { makeStyles } from 'tss-react/mui';
import { useSnapshot } from 'valtio';
import { AppPages } from '../../../common/routing/app-navigator';
import OxDataGrid from '../../../elements/OxDataGrid/OxDataGrid';
import {
  handleArtifactRowClick,
  loadArtifacts,
} from '../../actions/artifacts-actions';
import config from '../../config/artifacts-config.json';
import { useArtifactsTable } from '../../hooks/useArtifactsTable';
import { setLoadingSingleartifact } from '../../store-actions/artifacts-store-actions';
import ArtifactsStore from '../../stores/artifacts-store';
import { ArtifactInfo } from '../../types/artifacts-type';

const ArtifactsTable: FC = () => {
  const { classes } = useStyles();
  const columns = useArtifactsTable();
  const { artifacts, loading, selectedArtifactId } =
    useSnapshot(ArtifactsStore);

  const { onScroll } = useInfinityScroll({
    load: loadArtifacts,
    threshold: 0.9,
  });

  const handleClick = useCallback((clickedArtifact: ArtifactInfo) => {
    setLoadingSingleartifact(true);
    handleArtifactRowClick(clickedArtifact.id, AppPages.Artifacts);
    setLoadingSingleartifact(false);
  }, []);

  if (artifacts && artifacts.length === 0) {
    return null;
  }

  return (
    <div className={classes.tableContainer}>
      <OxDataGrid
        columns={columns}
        rows={artifacts}
        onScroll={onScroll}
        onRowClick={handleClick}
        activeRowKey='id'
        activeRowValue={selectedArtifactId}
        rowHeight={config.table.rowHeight}
        defaultColumnOptions={{
          sortable: true,
          resizable: false,
        }}
        loading={loading.isPending()}
      />
    </div>
  );
};

const useStyles = makeStyles()({
  tableContainer: {
    borderRadius: 10,
    overflow: 'hidden',
    width: '100%',
    height: '100%',
    position: 'relative',
  },
});

export default ArtifactsTable;
